import { createContext } from 'react';

export const EdgeLabelsContext = createContext<{ visible: boolean }>({ visible: true });
